import React, {useState, useEffect} from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import classnames from 'classnames/bind';
import Slider from 'rc-slider';
import ClickOut from 'react-click-out';
import analyseData from '../../../../utils/analyseData';
import actions from '../../../../redux/actions';
import style from './index.module.scss';
import {IState, Replacement} from '../../../../interface';
import localesReplacement from '../../../../utils/localesReplacement';
import {useDebounce} from 'use-debounce';

const cx = classnames.bind(style);

interface IProps {
  openHours: number | undefined;
  closeHours: number | undefined;
  replacements: Replacement;
  setOpenHours: (value: number) => void;
  setCloseHours: (value: number) => void;
}

//Opening hours dropdown component
export const OpeningHoursDropdown = (props: IProps) => {
  const {openHours, closeHours, replacements, setOpenHours, setCloseHours} =
    props;
  const [visible, setVisible] = useState<boolean>(false);
  const min = 6;
  const max = 24;
  const step = 1;
  const [open, setOpen] = useState<number>(
    openHours ? openHours : 6,
  );
  const [close, setClose] = useState<number>(
    closeHours ? closeHours : 24,
  );
  const [debounceValueOpen] = useDebounce(open, 1000);
  const [debounceValueClose] = useDebounce(close, 1000);
  const onChange = (v: number[] | number) => {
    if (_.isArray(v)) {
      setOpen(v[0]);
      setClose(v[1]);
    }
  };
  useEffect(() => {
    setOpenHours(debounceValueOpen);
    setCloseHours(debounceValueClose);
  }, [debounceValueOpen, debounceValueClose]);
  return (
    <ClickOut className='click-out' onClickOut={() => setVisible(false)}>
      <div className={`dropdown ${cx('dropdown')} ${visible ? 'open' : ''}`}>
        <div className='label' onClick={() => setVisible(!visible)}>
          {localesReplacement(replacements, 'Opening Hours')}
        </div>
        {/* Flyout for dropdown */}
        <div className={cx('flyout')}>
          <div className={cx('slider')}>
            <div
              className={cx('tooltip')}
              style={{left: analyseData.getPosition(min, max, open)}}
            >
              {moment().hours(open).minute(0).format('kk:mm')}
            </div>
            <div
              className={cx('tooltip', 'last')}
              style={{left: analyseData.getPosition(min, max, close)}}
            >
              {moment().hours(close).minute(0).format('kk:mm')}
            </div>
            {/* Rating ranger */}
            <Slider
              range
              min={min}
              max={max}
              defaultValue={[open, close]}
              step={step}
              allowCross={false}
              onChange={(v) => onChange(v)}
            />
          </div>
        </div>
      </div>
    </ClickOut>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  openHours: state.filter.openHours,
  closeHours: state.filter.closeHours,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setOpenHours: (value: number) => dispatch(actions.setOpenHours(value)),
  setCloseHours: (value: number) => dispatch(actions.setCloseHours(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OpeningHoursDropdown);
